import { clsx } from 'clsx';

export function cn(...inputs) {
 return clsx(inputs);
}

const DEFAULT_CURRENCY = 'GBP';

const CURRENCY_CONFIG = {
 GBP: { symbol: '£', locale: 'en-GB' },
 USD: { symbol: '$', locale: 'en-US' },
 EUR: { symbol: '€', locale: 'en-EU' },
 JPY: { symbol: '¥', locale: 'ja-JP' },
 CAD: { symbol: '$', locale: 'en-CA' },
 AUD: { symbol: '$', locale: 'en-AU' },
};

export function getCurrencySymbol() {
 let currency = localStorage.getItem('currency');
 if (!currency) {
 currency = DEFAULT_CURRENCY;
 localStorage.setItem('currency', DEFAULT_CURRENCY);
 }
 return (CURRENCY_CONFIG[currency] || CURRENCY_CONFIG[DEFAULT_CURRENCY]).symbol;
}

export function formatCurrency(amount) {
 const currency = localStorage.getItem('currency') || DEFAULT_CURRENCY;
 const { locale } = CURRENCY_CONFIG[currency] || CURRENCY_CONFIG[DEFAULT_CURRENCY];
 return new Intl.NumberFormat(locale, {
 style: 'currency',
 currency: currency,
 }).format(amount);
}

export function formatDate(date) {
 return new Date(date).toLocaleDateString('en-US', {
 year: 'numeric',
 month: 'short',
 day: 'numeric',
 });
}

export function getCurrentMonth() {
 const now = new Date();
 return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function getLastDayOfMonth(monthStr) {
 const [year, month] = monthStr.split('-').map(Number);
 // Create date for first day of next month, then subtract 1 day
 const lastDay = new Date(year, month, 0).getDate();
 return `${monthStr}-${String(lastDay).padStart(2, '0')}`;
}

export async function seedDefaultCategories(supabase, userId) {
 // Check if user already has categories
 const { data: existing, error: checkError } = await supabase
 .from('categories')
 .select('id')
 .eq('user_id', userId)
 .limit(1);

 if (checkError) {
 console.error('Error checking categories:', checkError);
 return;
 }

 // If user has categories, don't seed
 if (existing && existing.length > 0) {
 return;
 }

 // Seed default categories (reduced and deduplicated)
 const defaultCategories = [
 { name: 'Groceries', budgeted_amount: 500 },
 { name: 'Rent/Mortgage', budgeted_amount: 1500 },
 { name: 'Utilities', budgeted_amount: 200 },
 { name: 'Transportation', budgeted_amount: 300 },
 { name: 'Entertainment', budgeted_amount: 150 },
 { name: 'Savings', budgeted_amount: 500 },
 ];

 const categoriesToInsert = defaultCategories.map(cat => ({
 ...cat,
 user_id: userId,
 }));

 const { error: insertError } = await supabase
 .from('categories')
 .insert(categoriesToInsert);

 if (insertError) {
 console.error('Error seeding categories:', insertError);
 }
}

export function getCategorySpent(transactions, categoryId) {
 return transactions
 .filter(t => t.category_id === categoryId && t.amount < 0)
 .reduce((sum, t) => sum + Math.abs(t.amount), 0);
}

export function getProgressColor(percent) {
 if (percent > 100) return 'hsl(var(--destructive))';
 if (percent >= 100) return 'hsl(var(--success))';
 return 'hsl(var(--warning))';
}

